import React, { useState } from 'react';
import axios from 'axios';
import { toJpegFile, apiErrorMessage } from '../utils/imageFile';
import './KioskUploadPage.css';

function KioskUploadPage() {
  const [nickname, setNickname] = useState('');
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [picking, setPicking] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleFileChange = async (event) => {
    const selected = event.target.files && event.target.files[0];
    event.target.value = '';
    if (!selected) return;
    setPicking(true);
    setError(null);
    try {
      const jpeg = await toJpegFile(selected);
      if (preview) URL.revokeObjectURL(preview);
      setFile(jpeg);
      setPreview(URL.createObjectURL(jpeg));
    } catch (err) {
      setError(err.message || 'Could not read that photo. Try another.');
    } finally {
      setPicking(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!nickname.trim() || !file) return;
    setSubmitting(true);
    setError(null);
    try {
      const formData = new FormData();
      formData.append('nickname', nickname.trim());
      formData.append('file', file);
      const { data } = await axios.post('/api/kiosk/submit', formData, { timeout: 120000 });
      setResult(data);
    } catch (err) {
      setError(apiErrorMessage(err, 'Something went wrong. Please try again.'));
    } finally {
      setSubmitting(false);
    }
  };

  const reset = () => {
    if (preview) URL.revokeObjectURL(preview);
    setNickname('');
    setFile(null);
    setPreview(null);
    setResult(null);
    setError(null);
  };

  if (result) {
    return (
      <div className="kiosk-upload-page">
        <div className="kiosk-upload-card kiosk-upload-success">
          <span className="kiosk-upload-check" role="img" aria-label="Clapper board">🎬</span>
          <h1>Thanks, {nickname}!</h1>
          <p>
            Check the big screen — you're{' '}
            {result.queue_position <= 1 ? 'up next' : `#${result.queue_position} in line`}.
          </p>
          <button className="kiosk-upload-button secondary" onClick={reset}>
            Search another photo
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="kiosk-upload-page">
      <form className="kiosk-upload-card" onSubmit={handleSubmit}>
        <div className="kiosk-upload-brand">
          <img src="/logo.png" alt="" />
          <span>ATLAS <span className="accent">- COMPASS</span></span>
        </div>
        <h1>Search by photo</h1>
        <p className="kiosk-upload-sub">
          Enter your name, then take a selfie or pick a photo from your gallery.
        </p>

        <label className="kiosk-upload-label" htmlFor="kiosk-nickname">Your name</label>
        <input
          id="kiosk-nickname"
          type="text"
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
          placeholder="e.g. Ayşe"
          maxLength={40}
          autoComplete="name"
          required
        />

        <label className="kiosk-upload-photo" htmlFor="kiosk-camera">
          {preview ? (
            <img src={preview} alt="Selected" className="kiosk-upload-preview" />
          ) : (
            <span className="kiosk-upload-photo-placeholder">
              <i className="fa-solid fa-camera"></i>
              {picking ? 'Preparing photo…' : 'Take a selfie'}
            </span>
          )}
        </label>
        <input
          id="kiosk-camera"
          className="kiosk-upload-file"
          type="file"
          accept="image/*"
          capture="user"
          onChange={handleFileChange}
        />
        <label className="kiosk-upload-library" htmlFor="kiosk-library">
          Choose from gallery
        </label>
        <input
          id="kiosk-library"
          className="kiosk-upload-file"
          type="file"
          accept="image/*"
          onChange={handleFileChange}
        />

        {error && <p className="kiosk-upload-error">{error}</p>}

        <button type="submit" className="kiosk-upload-button" disabled={submitting || picking || !nickname.trim() || !file}>
          {submitting ? 'Searching…' : 'Search this movie'}
        </button>
      </form>
    </div>
  );
}

export default KioskUploadPage;
